export default __webpack_public_path__ + "static/media/portisIcon.f44aba13.png";